<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Content: {{ content.content_id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <strong class="text-uppercase" i18n>Content Details</strong>
    <hr />
    <dl class="row">
      <dt class="col-4" i18n>Created By</dt>
      <dd *ngIf="content.created_by !== null; else noUser" class="col-8">
        {{ content.created_by }}
      </dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Created On</dt>
      <dd class="col-8">{{ formatted_created_time }}</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Last Updated By</dt>
      <dd *ngIf="content.last_updated_by !== null; else noUser" class="col-8">
        {{ content.last_updated_by }}
      </dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Last Updated On</dt>
      <dd class="col-8">{{ formatted_updated_date }}</dd>
    </dl>
    <hr />

    <ng-template #noUser>
      <dd class="col-8" i18n>Unknown</dd>
    </ng-template>

    <ng-container *ngFor="let item of content | keyvalue">
      <dl class="row">
        <ng-container
          *ngIf="
            item.value !== null && item.value !== '' && item.key !== 'payload_records' && item.key !== 'action_button'
          "
        >
          <dt class="col-4">
            {{ item.key | replaceunderscore | titlecase }}
          </dt>
          <dd class="col-8" style="overflow-wrap: break-word">
            {{ item.value }}
          </dd>
        </ng-container>
      </dl>

      <ng-container *ngIf="item.key === 'action_button' && item.value !== null">
        <strong class="text-uppercase" i18n>Action Button</strong>
        <div *ngFor="let action_button of content.action_button">
          <div *ngFor="let item of action_button | keyvalue">
            <div *ngIf="item.value !== null && item.value !== ''">
              <dl class="row">
                <dt class="col-4">
                  {{ item.key | replaceunderscore | titlecase }}
                </dt>
                <dd class="col-8" style="overflow-wrap: break-word">
                  {{ item.value }}
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <hr />
      </ng-container>

      <ng-container *ngIf="item.key === 'payload_records' && item.value !== null">
        <hr />
        <strong *ngIf="content.payload_records?.length > 0" class="text-uppercase" i18n>Payload Records</strong>
        <div *ngFor="let payload_record of content.payload_records; let i = index">
          <nb-card accent="info">
            <nb-card-header>
              <div class="row">
                <div *ngIf="payload_record.payload_record_type !== 'banner'" class="col-auto mr-auto">
                  {{ payload_record.payload_record_type.split('_').join(' ') | titlecase }}
                </div>
                <div *ngIf="payload_record.payload_record_type === 'banner'" class="col-auto mr-auto">
                  {{ payload_record.payload_record_type | titlecase }}
                </div>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div *ngFor="let item of payload_record | keyvalue">
                <div *ngIf="item.value !== null && item.value !== ''">
                  <dl class="row">
                    <dt class="col-auto mr-auto">
                      {{ item.key | replaceunderscore | titlecase }}
                    </dt>
                    <dd class="col-auto" style="overflow-wrap: break-word">
                      {{ item.value }}
                    </dd>
                  </dl>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </ng-container>
    </ng-container>
  </nb-card-body>
  <nb-card-footer
    *ngIf="
      content.payload_records?.length > 0 &&
      ['contextual_message', 'personalized_offer'].includes(content.payload_records[0].payload_record_type)
    "
  >
    <div class="d-flex justify-content-end">
      <button
        nbButton
        status="info"
        [disabled]="!marketing.version || !marketing_translations.version"
        (click)="previewContent()"
        [nbSpinner]="!marketing.version || !marketing_translations.version"
        nbSpinnerStatus="info"
        i18n
      >
        Preview Content
      </button>
    </div>
  </nb-card-footer>
</nb-card>
